import { SignatureGeneratedEntity } from "./generated/SignatureGeneratedEntity";

export abstract class SignatureEntity extends SignatureGeneratedEntity {
    // Comment to preserve new line
}
